import { observable, action, computed } from 'mobx'
import _ from 'lodash'
import GameStore from '@/stores/GameStore'
import agent from '@/Agent'
import { guid } from '@/utils'
import { extractNameFromHTML } from '../utils'
import axios from 'axios'
import config from '@/Agent/config'

class PrePlayStore {
  constructor() {
    this.syncClock()
    this.syncInterval = setInterval(() => this.syncClock(), 300000)
  }

  @observable
  clockOffset = 0

  @action
  setClockOffset(val) {
    this.clockOffset = val
  }

  getServerTime() {
    return new Date(Date.now() + this.clockOffset)
  }

  async syncClock() {
    try {
      const clientTimeBefore = Date.now()
      const response = await axios.get(
        `${config.PROTOCOL}://${config.URL}/time`
      )
      const serverTime = response.data.time
      const clientTimeAfter = Date.now()
      const roundtrip = clientTimeAfter - clientTimeBefore
      const offset = serverTime - (clientTimeAfter - roundtrip / 2)
      this.setClockOffset(offset)
    } catch (e) {
      console.error('[Clock Sync] Failed to sync clock with server:', e)
    }
  }

  PlayColors = {
    liveplay: '#c61818',
    gamemaster: '#19d1bf',
    sponsor: '#495bdb',
    prize: '#9368aa',
  }

  subType = ''

  @observable
  isLoading = false
  @action
  setIsLoading(val) {
    this.isLoading = val
  }

  @observable
  teams = []
  @action
  setTeams(val) {
    this.teams = val
  }

  //preplayItemsBuffer = [] //split attempt
  @observable
  preplayItems = []
  @action
  setPrePlayItems(val) {
    if (val) this.updateGameAssetsWithQuantity(val)
    this.preplayItems = val
    /*
    //split attempt
    if (val) {
      this.updateGameAssetsWithQuantity(val)
      this.preplayItemsBuffer = val
      this.preplayItems = []
    }
    if(this.preplayItemsBuffer.length) this.preplayItems.push(...this.preplayItemsBuffer.splice(0, 800))
    */
  }

  @observable
  gameAssets = {}

  @observable
  combinedGameAssets = null

  updateGameAssetsWithQuantity(preplayItems) {
    let { gameAssets } = GameStore
    let { nextPlayItem, currentPlayItem } = this
    preplayItems = preplayItems.filter(preplayItem =>
      (preplayItem.subType || '').includes('gm_announce')
    )
    if (gameAssets) {
      let {
        currentPlayChecked,
        nextPlayChecked,
        currentPlayMsgChecked,
        nextPlayMsgChecked,
      } = 0
      const arraysToUpdate = [
        gameAssets.game ? gameAssets.game.msg || [] : [],
        gameAssets.game ? gameAssets.game.video || [] : [],
        gameAssets.sport_type ? gameAssets.sport_type.msg || [] : [],
        gameAssets.sport_type ? gameAssets.sport_type.video || [] : [],
      ]

      // Iterate through each array and add servedQuantity field to all objects
      arraysToUpdate.forEach(array => {
        array.forEach(obj => {
          obj.servedQuantity = 0
        })
      })
      const assetTypes = ['game', 'sport_type']
      if (preplayItems && preplayItems.length > 0) {
        preplayItems.forEach(item => {
          assetTypes.forEach(value => {
            const videos = _.get(gameAssets[value], 'video', [])
            const msgs = _.get(gameAssets[value], 'msg', [])
            videos.forEach(video => {
              let videoName = video ? video.name || '' : ''
              // adding a backslash before " if the video name has " (representing seconds eg: 3" video)
              videoName =
                videoName && videoName.includes('"')
                  ? videoName.replace(/"/g, '\\"')
                  : videoName
              const itemAnnouncements = item && _.get(item, 'announcements', [])
              const hasVideoInStack =
                itemAnnouncements &&
                itemAnnouncements[2] &&
                (itemAnnouncements[2].value || '').includes(videoName)

              // Checking next play item if it is GM Vid if not already checked
              if (!nextPlayChecked) {
                const nextPlayAnnouncements =
                  nextPlayItem && _.get(nextPlayItem, 'announcements', [])
                const hasVideoInNextPlayItem =
                  nextPlayAnnouncements &&
                  (nextPlayItem.subType || '').includes('gm_announce') &&
                  nextPlayAnnouncements[2] &&
                  (nextPlayAnnouncements[2].value || '').includes(videoName)
                if (hasVideoInNextPlayItem) {
                  nextPlayChecked = 1
                  video.servedQuantity = (video.servedQuantity || 0) + 1
                }
              }

              if (hasVideoInStack)
                video.servedQuantity = (video.servedQuantity || 0) + 1
            })

            msgs.forEach(msg => {
              const msgName = msg ? msg.name || '' : ''
              const itemAnnouncements = item && _.get(item, 'announcements', [])
              const hasMsgInStack =
                itemAnnouncements &&
                itemAnnouncements[2] &&
                (itemAnnouncements[2].value || '').includes(msgName)

              // Checking next play item if it is GM Msg if not already checked
              if (!nextPlayMsgChecked) {
                const nextPlayAnnouncements =
                  nextPlayItem && _.get(nextPlayItem, 'announcements', [])
                const hasMsgInNextPlayItem =
                  nextPlayAnnouncements &&
                  (nextPlayItem.subType || '').includes('gm_announce') &&
                  nextPlayAnnouncements[2] &&
                  (nextPlayAnnouncements[2].value || '').includes(msgName)
                if (hasMsgInNextPlayItem) {
                  nextPlayMsgChecked = 1
                  msg.servedQuantity = (msg.servedQuantity || 0) + 1
                }
              }

              if (hasMsgInStack)
                msg.servedQuantity = (msg.servedQuantity || 0) + 1
            })
          })
        })
      } else {
        assetTypes.forEach(value => {
          const videos = _.get(gameAssets[value], 'video', [])
          const msgs = _.get(gameAssets[value], 'msg', [])
          videos.forEach(video => {
            let videoName = video ? video.name || '' : ''
            // adding a backslash before " if the video name has " (representing seconds eg: 3" video)
            videoName =
              videoName && videoName.includes('"')
                ? videoName.replace(/"/g, '\\"')
                : videoName

            // Checking next play item if it is GM Vid if not already checked
            if (!nextPlayChecked) {
              const nextPlayAnnouncements =
                nextPlayItem && _.get(nextPlayItem, 'announcements', [])
              const hasVideoInNextPlayItem =
                nextPlayAnnouncements &&
                (nextPlayItem.subType || '').includes('gm_announce') &&
                nextPlayAnnouncements[2] &&
                (nextPlayAnnouncements[2].value || '').includes(videoName)
              if (hasVideoInNextPlayItem) {
                nextPlayChecked = 1
                video.servedQuantity = (video.servedQuantity || 0) + 1
              }
            }
          })

          msgs.forEach(msg => {
            const msgName = msg ? msg.name || '' : ''

            // Checking next play item if it is GM Msg if not already checked
            if (!nextPlayMsgChecked) {
              const nextPlayAnnouncements =
                nextPlayItem && _.get(nextPlayItem, 'announcements', [])
              const hasMsgInNextPlayItem =
                nextPlayAnnouncements &&
                (nextPlayItem.subType || '').includes('gm_announce') &&
                nextPlayAnnouncements[2] &&
                (nextPlayAnnouncements[2].value || '').includes(msgName)
              if (hasMsgInNextPlayItem) {
                nextPlayMsgChecked = 1
                msg.servedQuantity = (msg.servedQuantity || 0) + 1
              }
            }
          })
        })
      }
    }
    this.gameAssets = gameAssets
    try {
      this.combinedGameAssets = {
        msg: [...gameAssets.game.msg, ...gameAssets.sport_type.msg].sort(
          (a, b) => {
            // Sort by sort_order first, then alphabetically by text
            if (a.sort_order === b.sort_order) {
              return (a.name || '').localeCompare(b.name)
            }
            return a.sort_order - b.sort_order
          }
        ),
        video: [...gameAssets.game.video, ...gameAssets.sport_type.video].sort(
          (a, b) => {
            // Sort by sort_order first, then alphabetically by text
            if (a.sort_order === b.sort_order) {
              return (a.name || '').localeCompare(b.name)
            }
            return a.sort_order - b.sort_order
          }
        ),
      }
    } catch (error) {
      console.log(' error while combining assets : ', error)
      this.combinedGameAssets = null
    }
  }

  @observable
  nextPlayItem = null
  @action
  setNextPlayItem(val) {
    this.nextPlayItem = val
  }

  @observable
  currentPlayItem = null
  @action
  setCurrentPlayItem(val) {
    this.currentPlayItem = val
  }

  //unresolvedItemsBuffer = [] //split attempt
  @observable
  unresolvedItems = []
  @action
  setUnresolvedItems(val) {
    this.unresolvedItems = val
    /*
    //split attempt
    if (val) {
      this.unresolvedItemsBuffer = val
      this.unresolvedItems = []
    }
    if(this.unresolvedItemsBuffer.length) this.unresolvedItems.push(...this.unresolvedItemsBuffer.splice(0, 800))
    */
  }

  //resolvedItemsBuffer = [] //split attempt
  @observable
  resolvedItems = []
  @action
  setResolvedItems(val) {
    this.resolvedItems = val
    /*
    //split attempt
    if (val) {
      this.resolvedItemsBuffer = val
      this.resolvedItems = []
    }
    if(this.resolvedItemsBuffer.length) this.resolvedItems.push(...this.resolvedItemsBuffer.splice(0, 800))
    */
  }

  @observable
  tmpPreplayItem = null

  @observable
  multiplierChoices = []

  @observable
  groupPlays = []
  @action
  setGroupPlays(val) {
    this.groupPlays = val
  }

  @observable
  sessionButtons = {
    start: {
      backgroundColor: '#18c5ff',
      color: '#000000',
      text: 'start session',
      locked: true,
    },
    session: {
      text: '',
      locked: true,
    },
    interruption: {
      value: '',
      text: '',
      locked: false,
    },
    message: {
      value: '',
      text: '',
      locked: false,
    },
    end: {
      backgroundColor: '#18c5ff',
      color: '#000000',
      text: 'end session',
      locked: true,
    },
  }

  addToPresetItemsAnnounce(val) {
    const ids = val.map(v => v.id)
    this.presetItemsAnnounce = this.presetItemsAnnounce.filter(
      v => ids.indexOf(v.id) === -1
    )
    this.presetItemsAnnounce.push(...val)
  }

  @observable
  timePeriods = []
  @action
  setTimePeriods(val) {
    this.timePeriods = val
    this.addToPresetItemsAnnounce(val)
  }

  @observable
  interruptPlays = []
  @action
  setInterruptPlays(val) {
    this.interruptPlays = val
    this.addToPresetItemsAnnounce(val)
  }

  @observable
  messagePlays = []
  @action
  setMessagePlays(val) {
    this.messagePlays = val
    this.addToPresetItemsAnnounce(val)
  }

  @observable
  gmMesPlays = []
  @action
  setGmMesPlays(val) {
    this.gmMesPlays = val
  }

  @observable
  mesVidPlays = []
  @action
  setMesVidPlays(val) {
    this.mesVidPlays = val
  }

  @observable
  gmAnnouncemetPlay = {}

  @action
  setGmAnnouncement() {
    this.gmAnnouncemetPlay = this.messagePlays[1]
  }

  @observable
  sponsors = []

  @observable
  sponsorsxx = [
    {
      id: 1,
      name: 'platinum package',
      initial: 'p',
      initialColor: '#383644',
      backgroundColor: '#b2cbce',
      circleBorderColor: '#91a5c1',
      circleFill: '#a3c2cc',
      count: 10,
      length: 5,
      items: [
        { id: 11, name: 'sony', category: 'platinum' },
        { id: 12, name: 'panasonic', category: 'platinum' },
        { id: 13, name: 'heier', category: 'platinum' },
      ],
    },
    {
      id: 2,
      name: 'bronze package',
      initial: 'b',
      initialColor: '#3f2919',
      backgroundColor: '#e2a069',
      circleBorderColor: '#7c4724',
      circleFill: '#af643e',
      count: 2,
      length: 7,
      items: [
        { id: 21, name: 'volvo', category: 'bronze' },
        { id: 22, name: 'subaru', category: 'bronze' },
        { id: 23, name: 'toyota', category: 'bronze' },
        { id: 24, name: 'hyundai', category: 'bronze' },
      ],
    },
    {
      id: 3,
      name: 'silver package',
      initial: 's',
      initialColor: '#4c4c4c',
      backgroundColor: '#bababa',
      circleBorderColor: '#999999',
      circleFill: '#cecece',
      count: 5,
      length: 5,
      items: [
        { id: 31, name: 'iphone', category: 'silver' },
        { id: 32, name: 'samsung', category: 'silver' },
        { id: 33, name: 'motorola', category: 'silver' },
      ],
    },
    {
      id: 4,
      name: 'gold package',
      initial: 'g',
      initialColor: '#754b00',
      backgroundColor: '#ffde9c',
      circleBorderColor: '#f4a300',
      circleFill: '#ffda3e',
      count: 4,
      length: 5,
      items: [
        { id: 41, name: 'daikin', category: 'gold' },
        { id: 42, name: 'kolin', category: 'gold' },
        { id: 43, name: 'carrier', category: 'gold' },
      ],
    },
  ]

  TypeButtons = [
    {
      type: 'LivePlay',
      width: 10,
      text: 'live',
      color: '#c61818',
      id: 'header-button-liveplay',
    },
    {
      type: 'GameMaster',
      width: 18,
      text: 'gamemaster',
      color: '#19d1bf',
      id: 'header-button-gamemaster',
    },
    {
      type: 'Sponsor',
      width: 18,
      text: 'sponsor',
      color: '#495bdb',
      id: 'header-button-sponsor',
    },
    {
      type: 'Prize',
      width: 18,
      text: 'prize',
      color: '#9368aa',
      id: 'header-button-prize',
    },
    {
      type: 'Announce',
      width: 18,
      text: 'announce',
      color: '#000000',
      id: 'header-button-announce',
    },
  ]

  AwardList = {
    LivePlay: {
      backgroundColor: '#c61818',
      awards: [
        {
          id: 1,
          value: 'spot fee',
          bg: '#c61818',
          c: 'white',
          init: true,
          isLocked: true,
        },
      ],
      lockIcon: 'icon-lock-white.svg',
    },
    GameMaster: {
      backgroundColor: '#19d1bf',
      awards: [
        { id: 1, value: 'spot fee', bg: '#19d1bf', c: 'white', init: true },
        { id: 2, value: 'tokens', bg: '#ffb600', c: 'black' },
        { id: 3, value: 'points', bg: '#ffb600', c: 'black' },
        { id: 4, value: 'tokens, points', bg: '#ffb600', c: 'black' },
        { id: 5, value: 'use sponsor', bg: '#495bdb', c: 'white' },
      ],
    },
    Sponsor: {
      backgroundColor: '#495bdb',
      awards: [
        {
          id: 1,
          value: 'tokens',
          bg: '#ffb600',
          c: 'black',
          awardValues: { tokens: 50, points: 0 },
        },
        {
          id: 2,
          value: 'points',
          bg: '#ffb600',
          c: 'black',
          awardValues: { tokens: 0, points: 5000 },
        },
        {
          id: 3,
          value: 'tokens, points',
          bg: '#ffb600',
          c: 'black',
          init: true,
          awardValues: { tokens: 50, points: 5000 },
        },
        {
          id: 4,
          value: 'use sponsor',
          bg: '#495bdb',
          c: 'white',
          awardValues: { tokens: 50, points: 5000 },
        },
      ],
    },
    Prize: {
      backgroundColor: '#9368aa',
      awards: [
        {
          id: 1,
          value: 'star',
          bg: '#efdf17',
          c: 'black',
          init: true,
          isLocked: true,
        },
      ],
      lockIcon: 'icon-lock-black.svg',
    },
  }

  /*
  @action
  resetTmpPreplayItem() {
    if (this.tmpPreplayItem && this.tmpPreplayItem.choices) {
      this.tmpPreplayItem.choices = []
    }
  }
  @action
  setTmpPreplayItemChoice(val) {
    if (this.tmpPreplayItem && this.tmpPreplayItem.choices) {
      this.tmpPreplayItem.choices.push(val)
    }
  }

*/

  @action
  setTmpPreplayItem(val) {
    this.tmpPreplayItem = val
  }

  @observable
  presetItems = []

  @observable
  presetItemsAnnounce = []

  @action
  setPresetItems(val) {
    this.presetItems = val
  }
  @action
  resetPresetItems() {
    this.presetItems = []
    this.presetItemsAnnounce = []
  }

  @observable
  preSetItem = null
  @action
  setPresetItemObj(val) {
    this.preSetItem = val
  }

  @observable
  addToStackItem = null
  @action
  setAddToStackItem(val) {
    this.addToStackItem = val
  }

  @observable
  selectedTeam = null
  @action
  setSelectedTeam(val) {
    this.selectedTeam = val

    const stackToUpdate = { gameId: GameStore.gameId, plays: [] }

    if (this.preplayItems && this.preplayItems.length > 0) {
      for (let i = 0; i < this.preplayItems.length; i++) {
        stackToUpdate.plays.push({
          gameId: this.preplayItems[i].gameId,
          id: this.preplayItems[i].id,
          participantId: val ? val.publicId : null,
        })
      }
    }

    if (this.nextPlayItem) {
      stackToUpdate.plays.push({
        gameId: this.nextPlayItem.gameId,
        id: this.nextPlayItem.id,
        participantId: val ? val.publicId : null,
      })
    }

    // if (stackToUpdate && stackToUpdate.plays && stackToUpdate.plays.length > 0) {
    //   agent.GameServer.updateParticipantForStack(stackToUpdate)
    // }
  }

  @observable
  selectedSponsor = null
  @action
  setSelectedSponsor(val) {
    this.selectedSponsor = val
  }

  @observable
  isAddingStack = false
  @action
  setIsAddingStack(val) {
    this.isAddingStack = val
  }

  getPresetItemById(id, announce) {
    return this[`presetItems${announce ? 'Announce' : ''}`].filter(
      o => o.id === id
    )[0]
  }

  getPresetItemsByType(type) {
    let items = this.presetItems.filter(
      o =>
        (o.type.toLowerCase() === type.toLowerCase() || o.type.match(type)) &&
        !o.isMultiplier
    )

    return _.orderBy(
      items,
      [
        item => {
          if (item.sequence != null) return Number(item.sequence)
          return Number(item.id)
        },
      ],
      ['asc']
    )
  }

  pullMultiplierChoices(id) {
    this.multiplierChoices = []
    return new Promise(resolve => {
      this.setMultiplierChoicesById(id)
      resolve(this.multiplierChoices)
    })
  }

  setMultiplierChoicesById(id) {
    let parent = this.presetItems.filter(o => o.id === id)[0]
    console.log('PARENT 404 >>> ' + parent)
    if (parent) {
      parent.locked = false
      const exists = this.multiplierChoices.filter(o => o.id === parent.id)[0]
      //if (!exists) {
      this.multiplierChoices.push(parent)
      //}
      if (
        parent.type.toLowerCase() === 'liveplay' &&
        parent.choices &&
        parent.choices.length >= 2
      ) {
        for (let i = 0; i < parent.choices.length; i++) {
          let nextId = parent.choices[i].nextId
          if (nextId > 0) {
            this.setMultiplierChoicesByNextId(nextId)
          }
        }
      }
    }
  }

  setMultiplierChoicesByNextId(nextId) {
    let item = this.presetItems.filter(o => o.id === nextId)[0]
    if (item) {
      this.setMultiplierChoicesById(item.id)
    }
  }

  levels = []

  getStarMax(presets) {
    this.levels = []
    let max = 1
    return new Promise(resolve => {
      const major = presets[0]
      this.levels.push(max)
      major.choices.forEach(a => {
        if (a.nextId) {
          this.levels.push(max + 1)
          this.deepStarMax(presets, a, max + 1)
        }
      })

      const returnValue = _.max(this.levels)
      resolve(returnValue)
    })
  }

  deepStarMax(presets, pre, max) {
    const b = presets.filter(o => o.id === pre.nextId)[0]
    if (b) {
      b.choices.forEach(c => {
        if (c.nextId) {
          this.levels.push(max + 1)
          this.deepStarMax(presets, c, max + 1)
        }
      })
    }
  }

  prePicks = []
  setPrePicks(val) {
    this.prePicks = val
  }

  @action
  resetValues() {
    this.isLoading = false
    this.teams = []
    this.preplayItems = []
    this.nextPlayItem = null
    this.currentPlayItem = null
    this.unresolvedItems = []
    this.resolvedItems = []
    this.tmpPreplayItem = null
    this.multiplierChoices = []
    this.groupPlays = []
    this.sessionButtons = {
      start: {
        backgroundColor: '#18c5ff',
        color: '#000000',
        text: 'start session',
        locked: true,
      },
      session: {
        text: '',
        locked: true,
      },
      interruption: {
        value: '',
        text: '',
        locked: false,
      },
      message: {
        value: '',
        text: '',
        locked: false,
      },
      end: {
        backgroundColor: '#18c5ff',
        color: '#000000',
        text: 'end session',
        locked: true,
      },
    }
    this.timePeriods = []
    this.interruptPlays = []
    this.messagePlays = []
    this.gmMesPlays = []
    this.mesVidPlays = []
    this.presetItems = []
    this.presetItemsAnnounce = []
    this.addToStackItem = null
    this.selectedTeam = null
    this.selectedSponsor = null
    this.isAddingStack = false
    this.levels = []
    this.prePicks = []
  }

  @action
  setUpdatedPlay(val) {
    const idx = this.preplayItems.findIndex(
      o => (o.id || o.gamePlayId) == (val.id || val.gamePlayId)
    )
    if (idx > -1) {
      this.preplayItems.splice(idx, 1, val)
    }

    if (
      this.nextPlayItem &&
      (this.nextPlayItem.id || this.nextPlayItem.gamePlayId) ==
        (val.id || val.gamePlayId)
    ) {
      this.nextPlayItem = val
    }

    if (
      this.currentPlayItem &&
      (this.currentPlayItem.id || this.currentPlayItem.gamePlayId) ==
        (val.id || val.gamePlayId)
    ) {
      this.currentPlayItem = val
    }
  }

  @observable
  operatorId = null
  @observable
  isFirstOperator = false
  @observable
  mainOperatorId = null
  @observable
  activeSessionsCount = 0
  @observable
  isOperatorDataSet = false

  @computed
  get isMainOperator() {
    return (
      this.operatorId &&
      this.mainOperatorId &&
      this.operatorId === this.mainOperatorId
    )
  }

  @action
  setOperatorData(data) {
    this.isOperatorDataSet = true
    if (data) {
      if (data.operatorId !== undefined) {
        this.operatorId = data.operatorId
      }
      if (data.isFirstOperator !== undefined) {
        this.isFirstOperator = data.isFirstOperator
      }
      if (data.mainOperatorId !== undefined) {
        this.mainOperatorId = data.mainOperatorId
      }
      if (data.activeSessionsCount !== undefined) {
        this.activeSessionsCount = data.activeSessionsCount
      }
    }
  }

  @observable
  isTimerStoppedFirstPlay = false

  @action
  setFirstPlayTimerState() {
    if (this.isOperatorDataSet && !this.isTimerStoppedFirstPlay) {
      this.isTimerStoppedFirstPlay = true
    }
  }

  @action
  setMainOperatorId(val) {
    if (val && typeof val === 'object') {
      this.mainOperatorId = val.mainOperatorId
      if (val.activeSessionsCount !== undefined) {
        this.activeSessionsCount = val.activeSessionsCount
      }
    } else {
      this.mainOperatorId = val
    }
  }

  liveEditingItems = []

  @action
  setLiveEditingItems(val, isRemoval) {
    if (isRemoval && val) {
      this.liveEditingItems = this.liveEditingItems.filter(item => {
        return item && item.gamePlayId !== val.gamePlayId
      })
    } else if (val) {
      const index = this.liveEditingItems.findIndex(item => {
        return item && item.gamePlayId === val.gamePlayId
      })

      if (index === -1) {
        this.liveEditingItems.push(val)
      } else {
        this.liveEditingItems[index] = val
      }
    }
  }
}

export default new PrePlayStore()



// WEBPACK FOOTER //
// src/stores/PrePlayStore.js